import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import alarmCard_nl from 'shared/components/alarm-card/translations/alarm-card_nl.json';
import copyButton_nl from 'shared/components/buttons/copy-button/translations/copy-button_nl.json';
import confirmationPopup_nl from 'shared/components/confirmation-pop-up/translations/confirmation-popup_nl.json';
import dataGrid_nl from 'shared/components/data-grid/translations/data-grid_nl.json';
import dateRangePicker_nl from 'shared/components/date-range-picker/translations/date-range-picker_nl.json';
import errorHandling_nl from 'shared/components/error/translations/error-handling_nl.json';
import monintoring_nl from 'shared/components/monitoring/translations/monitoring_nl.json';
import searchbar_nl from 'shared/components/search-bar/translations/searchbar_nl.json';
import statusCard_nl from 'shared/components/status-card/translations/status-card_nl.json';
import multiValueFilterChip_nl from 'shared/components/table-filter-chips/multi-value-filter-chip/translations/multi-value-filter-chip_nl.json';
import filterChip_nl from 'shared/components/table-filter-chips/translations/filter-chip_nl.json';
import table_nl from 'shared/components/table/translations/table_nl.json';
import timeline_nl from 'shared/components/timeline/translations/timeline_nl.json';
import devices_types_nl from 'shared/translations/device_types_nl.json';
import featureFlags_nl from 'shared/translations/feature-flags_nl.json';
import io_event_types_nl from 'shared/translations/io_event_types_nl.json';

import appInformation_nl from 'features/app-information/translations/app-information_nl.json';
import careConnectSettings_nl from 'features/care-connect-settings/translations/care-connect-settings_nl.json';
import connectors_nl from 'features/connectors/translations/nl/connectors.json';
import dashboard_nl from 'features/dashboard/translations/dashboard_nl.json';
import device_details_nl from 'features/device/device-details/translations/device-details_nl.json';
import devices_nl from 'features/device/devices/translations/devices_nl.json';
import linkableDevice_nl from 'features/device/linkable-device/translations/linkable-device_nl.json';
import sendTestEvent_nl from 'features/device/send-test-event/translations/send-test-event_nl.json';
import emergencyAlarm_nl from 'features/emergency-alarm-settings/translations/emergency-alarm_nl.json';
import explanationLinks_nl from 'features/explanation-links/translations/explanation-links_nl.json';
import faultsHistory_nl from 'features/faults-history/translations/faults-history_nl.json';
import feature_subscriptions_nl from 'features/feature-subscriptions/translations/feature-subscriptions_nl.json';
import gateway_nl from 'features/gateway/translations/gateway_nl.json';
import history_nl from 'features/history/translations/history_nl.json';
import integrations_nl from 'features/integrations/translations/integrations_nl.json';
import login_nl from 'features/login/translations/login_nl.json';
import malfunctionNotifications_nl from 'features/malfunction-notification-settings/translations/malfunction-notifications_nl.json';
import mediaserverSwitches_nl from 'features/mediaserver-settings/translations/mediaserver-settings_nl.json';
import menu_nl from 'features/menu/translations/menu_nl.json';
import organisation_nl from 'features/organisation/translations/organisation_nl.json';
import residentsChangeLog_nl from 'features/residents/resident-change-logs/translations/residents-change-log_nl.json';
import residents_nl from 'features/residents/resident-navigation/translations/residents_nl.json';
import residentsSettings_nl from 'features/residents/resident-settings/translations/residents-settings_nl.json';
import permissions_nl from 'features/role/translations/permissions_nl.json';
import role_nl from 'features/role/translations/role_nl.json';
import linkableScenarios_nl from 'features/scenario/linkable-scenario/translations/linkable-scenarios_nl.json';
import scenario_nl from 'features/scenario/translations/scenario_nl.json';
import settings_nl from 'features/settings/translations/settings_nl.json';
import domip_nl from 'features/systems/domip/translations/nl/domip.json';
import ip_unit_nl from 'features/systems/ip-unit/translations/nl/ip-unit.json';
import IS32_nl from 'features/systems/IS32/translations/nl/IS32.json';
import systems_nl from 'features/systems/translations/nl/systems.json';
import temporaryAccess_nl from 'features/temporary-access/translations/temporary-access_nl.json';
import tenants_nl from 'features/tenants/translations/tenants_nl.json';
import wanderingBoundarySettings_nl from 'features/wandering-boundary-settings/translations/wandering-boundary-settings_nl.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      nl: {
        menu: menu_nl,
        login: login_nl,
        organisation: organisation_nl,
        role: role_nl,
        permissions: permissions_nl,
        gateway: gateway_nl,
        faultsHistory: faultsHistory_nl,
        errorHandling: errorHandling_nl,
        confirmationPopup: confirmationPopup_nl,
        linkableDevice: linkableDevice_nl,
        systems: systems_nl,
        connectors: connectors_nl,
        devices: devices_nl,
        deviceTypes: devices_types_nl,
        deviceDetails: device_details_nl,
        integrations: integrations_nl,
        scenario: scenario_nl,
        table: table_nl,
        linkableScenarios: linkableScenarios_nl,
        residentsSettings: residentsSettings_nl,
        copyButton: copyButton_nl,
        history: history_nl,
        filterChip: filterChip_nl,
        search: searchbar_nl,
        dashboard: dashboard_nl,
        tenants: tenants_nl,
        appInformation: appInformation_nl,
        alarmCard: alarmCard_nl,
        statusCard: statusCard_nl,
        timeline: timeline_nl,
        temporaryAccess: temporaryAccess_nl,
        dateRangePicker: dateRangePicker_nl,
        monitoring: monintoring_nl,
        settings: settings_nl,
        dataGrid: dataGrid_nl,
        emergencyAlarm: emergencyAlarm_nl,
        wanderingBoundarySettings: wanderingBoundarySettings_nl,
        malfunctionNotifications: malfunctionNotifications_nl,
        mediaserverSettings: mediaserverSwitches_nl,
        careConnectSettings: careConnectSettings_nl,
        explanationLinks: explanationLinks_nl,
        sendTestEvent: sendTestEvent_nl,
        multiValueFilterChip: multiValueFilterChip_nl,
        IS32: IS32_nl,
        domip: domip_nl,
        residentsChangeLog: residentsChangeLog_nl,
        residents: residents_nl,
        ipUnit: ip_unit_nl,
        featureFlags: featureFlags_nl,
        ioEventTypes: io_event_types_nl,
        featureSubscriptions: feature_subscriptions_nl,
      },
    },
    fallbackLng: 'nl',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
